import { render, staticRenderFns } from "./FaIcon.vue?vue&type=template&id=2b7285b8&scoped=true"
import script from "./FaIcon.vue?vue&type=script&lang=js"
export * from "./FaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7285b8",
  null
  
)

export default component.exports